export default __webpack_public_path__ + "static/feature-insights-c39a41d7ba2a6fc60bd5fb7e9eb02259.png";